import React from 'react';
import * as S from './ProfileMenuIcon.styles';
import { useAuthStore } from '@/store/useAuthStore';
import { ProfileDefaultIcon } from '@/components/UI/Icons/Icons';

export const ProfileMenuIcon = () => {
  const [userInfo] = useAuthStore(state => [state.userInfo]);
  const { shop } = userInfo || {};

  return (
    <S.ProfileMenuIconBox data-testid="profile-menu-icon">
      {shop?.logo ? (
        <img
          alt=""
          src={shop.logo.url}
          width={34}
          height={34}
          style={{ objectFit: 'contain', borderRadius: '50%' }}
          loading="lazy"
        />
      ) : (
        <ProfileDefaultIcon />
      )}
    </S.ProfileMenuIconBox>
  );
};
